# What sentence a REFUSED clientAPI call shows the user.
#
# Lives here, as a plain CommonJS module, for the same two reasons as
# clientParamSplit.coffee: client_api.coffee is ESM at module scope (so it
# cannot be required by a test harness), and this is a contract shared with the
# SERVER's error serialization in model.coffee.
#
# THE DEFECT THIS EXISTS FOR (card 6a6ce721d4a955ed6b43b3f3): axios rejects with
# its OWN Error, whose `.message` is the generic "Request failed with status
# code 404". The server's actual sentence — "Page: commit not found.",
# "Commit <id> is not a snapshot of Page <id>." — is sitting untouched at
# `error.response.data` and was thrown away, so the admin's red panel showed a
# status code where a reason belonged. The SOCKET transport never had this
# problem: client_api.coffee's transactionComplete handler already builds its
# rejection from `data.error.message`, so the identical refusal was legible over
# one transport and illegible over the other.
#
# THE BODY ARRIVES IN MORE THAN ONE SHAPE, and that is the whole difficulty.
# model.coffee's remote-method catch sends it two ways:
#   res.status(status).json {message, code}   when clientSafeErrorCode(err) hits
#                                             the framework allowlist
#   res.status(status).send err.message       otherwise — a BARE STRING body
# and bootstrap.coffee's federated/admin routes send a third, `{error: "..."}`.
# A chain that only reaches for `.message` therefore falls through to the
# generic text on the commonest shape, and a chain that stringifies whatever it
# finds renders '[object Object]' — the exact regression the allowlist comment
# at model.coffee:899-905 records having been caused once already. So every
# shape is matched EXPLICITLY and anything unrecognised falls back rather than
# being coerced.
#
# NOT every string body is a message. A 502/504 from the proxy in front of the
# instance answers with a whole HTML error document, and a Blob body (a failed
# blobOperation download) is an object with no message at all. Rendering either
# one in the panel is worse than the status code it replaced, so both are
# rejected and the caller keeps axios's sentence.

# A refusal message is one sentence. Anything appreciably longer is a document
# that happens to be text, not something to put in a <Typography>.
MAX_MESSAGE_LENGTH = 500

isRenderableMessage = (value) ->
  return false unless typeof value == 'string'
  trimmed = value.trim()
  return false if trimmed == ''
  return false if trimmed.length > MAX_MESSAGE_LENGTH
  # An HTML error page from a proxy, not the application's sentence.
  return false if trimmed.charAt(0) == '<'
  true

# Every place the server is known to put a human-readable refusal, in the order
# a body carrying more than one should be read.
messageCandidates = (data) ->
  return [] unless data?
  # Bare-string body: res.send err.message
  return [data] if typeof data == 'string'
  return [] unless typeof data == 'object'
  # An array is a payload, never a message; Blob/ArrayBuffer bodies land here
  # too and simply yield no candidates.
  return [] if Array.isArray data
  candidates = []
  candidates.push data.message
  if typeof data.error == 'string'
    candidates.push data.error
  else if data.error? and typeof data.error == 'object' and not Array.isArray(data.error)
    candidates.push data.error.message
  candidates

# The string to show for a rejected HTTP call. ALWAYS returns a non-empty
# string, because every admin call site does `error.message || error.toString()`
# and a non-string here would put '[object Object]' on the screen.
serverErrorMessage = (error) ->
  for candidate in messageCandidates(error?.response?.data)
    return candidate.trim() if isRenderableMessage candidate

  fallback = error?.message
  return fallback if typeof fallback == 'string' and fallback.trim() != ''
  'Unknown error occurred'

module.exports = {serverErrorMessage, isRenderableMessage, MAX_MESSAGE_LENGTH}
